import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import s from "./style.module.scss";
import Item from "./Item";

import "swiper/css";
import "swiper/css/pagination";
import { NewsListApi } from "./api";
import { INewsItem } from "./api/models";

const HeroSlider: React.FC = () => {
  const [news, setNews] = useState<INewsItem[]>([]);

  useEffect(() => {
    NewsListApi().then((res) => setNews(res));
  }, []);

  return (
    <section className={s.hero}>
      <Swiper
        pagination={{ clickable: true }}
        slidesPerView={1}
        modules={[Pagination]}
      >
        {news
          .filter((item) => item.promo === 1)
          .map((item, key) => (
            <SwiperSlide className={s.slide} key={key}>
              <Item {...item} />
            </SwiperSlide>
          ))}
      </Swiper>
    </section>
  );
};

export default HeroSlider;
